import ForgotPasswordForm from "@/components/organisms/forms/auth/forgot-password-form";

type ForgotPasswordViewProps = {
  resolution: Resolution;
};

const ForgotPasswordView = ({ resolution }: ForgotPasswordViewProps) => {
  return <ForgotPasswordForm locale={resolution.locale} />;
};

export default ForgotPasswordView;
